import { render } from "./PasswordChangeModal.vue?vue&type=template&id=fc8ca2f4&scoped=true"
import script from "./PasswordChangeModal.vue?vue&type=script&lang=js"
export * from "./PasswordChangeModal.vue?vue&type=script&lang=js"

import "./PasswordChangeModal.vue?vue&type=style&index=0&id=fc8ca2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8ca2f4"]])

export default __exports__